export default "__VITE_ASSET__BDxpNqfv__"